import React from "react";

import Content from "~/ui/structure/Content";
import { FEATURES_BY_PLAN, PLANS } from "~/constanst/plans";
import PlansFeaturesBlock from "./PlansFeaturesBlock";
import { Divider, Grid, PseudoBox, Text } from "@chakra-ui/core";
import Heading from "~/ui/display/Heading";
import { useTranslation } from "~/i18n/hooks";

const PlansFeatures: React.FC = () => {
  const t = useTranslation();

  return (
    <Content paddingX={6} paddingY={12}>
      {FEATURES_BY_PLAN.map((block, index) => {
        return (
          <PseudoBox key={index}>        
            <Grid templateColumns={{base: "1fr repeat(3, 50px)", md: "1fr repeat(3, 250px)"}} gap={6} mt={23} mb={1} alignItems={"center"}>
              <Text color={"gray.700"} fontWeight={600}>{t(`${block.title}`)}</Text>
              {PLANS.map((plan) => {
                return (
                  <Heading key={plan.label} fontSize={{base: "sm", md: "lg"}} textAlign={{base: "left", md: "center"}}>
                    {t(plan.label)}
                  </Heading>
                )
              })}
            </Grid>
            <Divider borderColor={"black"} />
            <PlansFeaturesBlock block={block} />
          </PseudoBox>
        )
      })}
    </Content>
  );
};

export default PlansFeatures;
